import { MQTT_HUB_URL } from '../../shared/api/apiConfig';
import { useRealtimeFeedHub } from '../../shared/realtime/useRealtimeFeedHub';

export function useMqttHub({
  onHistoryLoaded,
  onMessageReceived,
  onConnectionStateChange,
} = {}) {
  return useRealtimeFeedHub(MQTT_HUB_URL, {
    events: [
      {
        name: 'MqttHistory',
        handler: (messages) => onHistoryLoaded?.(messages ?? []),
      },
      {
        name: 'ReceivedMqttMessage',
        handler: onMessageReceived,
      },
    ],
    onConnectionStateChange,
    logLabel: 'MQTT hub',
  });
}
